import { Pages } from '../components/Pages/Pages';

import { UrlPlatform } from '@/features/pages';
import { useDepartmentStore } from '@/stores/department';
import { Platforms } from '@/types';

// The `meta` segment covers both Instagram and Facebook Messenger pages, which the server
// serves as a single `instagram` platform.
const URL_TO_PLATFORM_ENUM: Record<UrlPlatform, Platforms> = {
  instagram: Platforms.instagram,
  telegram: Platforms.telegram,
  meta: Platforms.instagram,
};

type Props = {
  platform: UrlPlatform;
};

export const ProphetPages = ({ platform }: Props) => {
  const department = useDepartmentStore((state) => state.selected);

  return <Pages platform={URL_TO_PLATFORM_ENUM[platform]} department={department} />;
};
